<template>
  <div>
    <el-table
            :data="timeList"
            ref="timeListRef"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%">
      <el-table-column
              type="selection">
      </el-table-column>
      <el-table-column
              prop="dateString"
              label="修正时间">
      </el-table-column>
      <!--<el-table-column-->
      <!--        prop="name"-->
      <!--        label="姓名"-->
      <!--        width="120">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--        prop="province"-->
      <!--        label="省份"-->
      <!--        width="120">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--        prop="city"-->
      <!--        label="市区"-->
      <!--        width="120">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--        prop="address"-->
      <!--        label="地址"-->
      <!--        width="300">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
      <!--        prop="zip"-->
      <!--        label="邮编"-->
      <!--        width="120">-->
      <!--</el-table-column>-->
      <el-table-column
              label="操作">
        <template slot-scope="scope">
          <!--<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>-->
          <el-button type="text" size="small" @click="deleteOne(scope.row)">取消修正</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <!--<el-button @click="toggleAll()">-->
      <!--<span v-if="!isSelectAll">-->
      <!--  全选-->
      <!--</span>-->
      <!--  <span v-if="isSelectAll">-->
      <!--  全不选-->
      <!--</span>-->
      <!--</el-button>-->
      <el-button type="danger" v-if="selectedRowArray.length > 0" @click="deleteMulti(selectedRowArray)">取消选中项的修正({{selectedRowArray.length}})</el-button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import MD5 from 'js-md5';

  export default {
    name: "changeRodHistoryTable",
    props: {
      pointId: {
        type: String,
        required: true
      }
    },
    data () {
      return {

        isSelectAll: false,
        timeList: [],
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1517 弄',
          zip: 200333
        }, {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1519 弄',
          zip: 200333
        }, {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        }],
        selectedRowArray: []
      }
    },
    methods: {
      init () {
        let _this = this;
        // 请求数据
        let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
        this.$http.get('/front/data/findDeltaTimeList', {
            params: {
              userId: this.$store.state.userId,
              pointId:this.pointId,
              auth_userId:this.$store.state.auth_userId,
              auth_timestamp:this.$store.state.auth_timestamp,
              token:MD5(hash),
            },
          }).then(function (res) {
          // let resData = res.body.data;

          if(res && res.body.errcode && res.body.errcode === -1){
            // console.log('uploadDelta',res.body.msg);
            _this.$message.error(res.body.msg);
          }else{
            _this.timeList = res.body.data.sort((a,b)=>{
              return b.unixTime - a.unixTime;
            });
            // _this.$message.success('修正成功');
          }

        }).catch(function (res) {
          this.$message(res.body.msg);
        })
      },
      handleSelectionChange (arrayValue) {
        let _this = this;
        _this.selectedRowArray = arrayValue;
      },
      toggleAll () {
        let _this = this;
        if (_this.timeList && _this.timeList.length > 0) {
          _this.timeList.forEach(row => {
            _this.selectedRowArray.push(row);
            this.$refs.timeListRef.toggleRowSelection(row);
          });
          _this.isSelectAll = true;
        } else {
          _this.selectedRowArray = [];
          this.$refs.timeListRef.clearSelection();
          _this.isSelectAll = false;
        }
      },
      deleteOne (row) {
        let _this = this;
        _this.deleteMulti([row]);
      },
      deleteMulti (rowArray) {
        let _this = this;

        let paramTimestampList = rowArray.map((r)=>{
          return r.unixTime;
        });

        this.$confirm(`取消${rowArray.length}个修正，此操作将无法撤回, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
          this.$http.delete('/front/data/batchDeleteDelta', {
              params: {
                userId: this.$store.state.userId,
                pointId:this.pointId,
                auth_userId:this.$store.state.auth_userId,
                auth_timestamp:this.$store.state.auth_timestamp,
                token:MD5(hash),
                timestampList:paramTimestampList.join(',')
              },
            }).then(function (res) {
            // let resData = res.body.data;

            if(res && res.body.errcode && res.body.errcode === -1){
              // console.log('uploadDelta',res.body.msg);
              _this.$message.error(res.body.msg);
            }else{
              _this.$message.success('取消修正成功');
            }

            _this.init();

          }).catch(function (res) {
            _this.$message(res.body.msg);
          });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });



      },
      handleClick(row) {
        // console.log(row);
      }
    },
    mounted() {
      let _this = this;
      _this.init();
    }
  }
</script>

<style scoped>

</style>
